module.exports = __webpack_public_path__ + "static/media/lack-protect.0de1d3c9.png";